<template>
  <div id="catalog" class="w-full h-full" style="animation-duration: 0.3s">
    <div class="bg-ec-gray-100 h-10 w-full border-b-4 border-gray-200">
      <p class="px-8 py-2 text-gray-700 font-bold">Catalog Grouping
        <i @click="$emit('reset', 'catalog')" class="el-icon-refresh-right float-right text-2xl cursor-pointer"></i>
      </p>
    </div>
    <div class="bg-ec-gray-100 mt-2 rounded px-8 pt-6 pb-8 mb-4">
      <Catalog
        v-for="n in catalogCount"
        @isDirty="catalogValidation"
        :key="n"
        @add="catalogIsValid = false"
        @minus="catalogIsValid = true"
        :count="catalogCount"
        :level="n"
        :action="action"
      />
    </div>
    <div class="bg-ec-gray-100 h-10 w-full border-b-4 border-gray-200">
      <p class="px-8 py-2 text-gray-700 font-bold">Outlets Grouping
        <i @click="$emit('reset', 'outlets')" class="el-icon-refresh-right float-right text-2xl cursor-pointer"></i>
      </p>
    </div>
    <div class="bg-ec-gray-100 mt-2 rounded px-8 pt-6 pb-8 mb-4">
      <Outlet
        v-for="n in outletCount"
        @isDirty="outletValidation"
        :key="n"
        @add="outletIsValid = true"
        @minus="outletIsValid = true"
        :count="outletCount"
        :level="n"
        :action="action"
      />
      <div class="flex items-center" :class="{'justify-between': action === 'create', 'justify-end' : action === 'edit'}">
        <el-button v-if="action === 'create'" @click="$emit('setSteps',{page: 'basic', step: 0})" type="default">Prev</el-button>
        <el-button v-if="action === 'create'" @click="next()" type="primary">Next</el-button>
        <el-button v-if="action === 'edit'" @click="$emit('updateCatalog')" type="primary">
          <vue-loaders v-if="loading" name="ball-clip-rotate" color="white" scale="0.5"></vue-loaders>
          <span v-if="!loading">Update</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import Catalog from './_includes/Catalog.vue';
import Outlet from './_includes/Outlet.vue';
import ProductMixin from '../../../mixins';

export default {
  name: 'CatalogForm',
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: 'create',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      catalogIsValid: false,
      outletIsValid: true,
    };
  },
  components: {
    Catalog,
    Outlet,
  },
  computed: {
    catalogCount() {
      const count = Object.keys(this.$store.state.InventoryModule.Products[this.action].catalog).length;
      if (count === 0) {
        return 1;
      }
      return count;
    },
    outletCount() {
      const count = Object.keys(this.$store.state.InventoryModule.Products[this.action].outlets).length;
      if (count === 0) {
        return 1;
      }
      return count;
    },
  },
  mixins: [validationMixin, ProductMixin],
  methods: {
    next() {
      if (this.catalogIsValid && this.outletIsValid) {
        this.$emit('setSteps', { page: 'attribute', step: 2 });
      }
    },

    catalogValidation(args) {
      this.catalogIsValid = args;
    },

    outletValidation(args) {
      this.outletIsValid = args;
    },
  },
  async mounted() {
    await this.$store.dispatch('InventoryModule/Catalog/fetchAllCategories');
    await this.$store.dispatch('OutletModule/fetchAllOutlets');
  },
};
</script>
